import { Anchor, Group, Table, Text } from '@mantine/core'
import { formatShortDate } from '@markku/utils'
import { IconCalendarEvent, IconHistory } from '@tabler/icons-react'
import type { ReactNode } from 'react'
import { ServiceLabel } from './ServiceLabel'
import { StatusCell } from './StatusCell'
import { useServiceDisplay } from './useServiceDisplay'
import type { Service } from './utils'

export function ServiceTableRow({
  service,
  companyId,
}: {
  service: Service
  companyId: string
}) {
  const { meta, statusLabel, openVisit } = useServiceDisplay(service, companyId)

  return (
    <Table.Tr>
      <Table.Td>
        <ServiceLabel service={service} color={meta.color} />
      </Table.Td>

      <Table.Td>
        <StatusCell
          service={service}
          statusLabel={statusLabel}
          color={meta.color}
        />
      </Table.Td>

      <Table.Td>
        <VisitCell
          icon={<IconHistory size={15} color="var(--mantine-color-gray-6)" />}
          date={service.lastCompletedDate}
          visitId={service.lastCompletedVisitId}
          staff={service.lastVisitStaff}
          onOpen={openVisit}
        />
      </Table.Td>

      <Table.Td>
        <VisitCell
          icon={
            <IconCalendarEvent size={15} color="var(--mantine-color-gray-6)" />
          }
          date={service.nextScheduledDate}
          visitId={service.nextScheduledVisitId}
          staff={service.nextVisitStaff}
          onOpen={openVisit}
        />
      </Table.Td>
    </Table.Tr>
  )
}

function VisitCell({
  icon,
  date,
  visitId,
  staff,
  onOpen,
}: {
  icon: ReactNode
  date: string | null
  visitId: number | null
  staff: string[]
  onOpen: (id: number) => void
}) {
  if (!date || !visitId) {
    return (
      <Text size="sm" c="dimmed">
        –
      </Text>
    )
  }
  return (
    <Group gap={6} wrap="nowrap" align="center">
      {icon}
      <Anchor
        component="button"
        type="button"
        underline="always"
        c="brandBrown.7"
        fw={600}
        size="sm"
        ta="left"
        onClick={() => onOpen(visitId)}
      >
        {formatShortDate(date)}
        {staff.length > 0 ? ` · ${staff.join(', ')}` : ''}
      </Anchor>
    </Group>
  )
}
